import { render, staticRenderFns } from "./DevBlog.vue?vue&type=template&id=73da2c53&"
import script from "./DevBlog.vue?vue&type=script&lang=js&"
export * from "./DevBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports